export interface ObjectionPair {
  objection: string;
  response: string;
}

export interface SalesProfile {
  id: string;
  agentName: string;
  tone: 'profesional' | 'directo' | 'amigable' | 'consultivo';
  closingStyle: 'consultivo' | 'directo' | 'suave' | 'urgente';
  greetingTemplate: string | null;
  objectionHandling: ObjectionPair[] | null;
  negotiationRules: string[] | null;
  keyPhrases: string[] | null;
  forbiddenPhrases: string[] | null;
  maxDiscountWithoutApproval: number;
  upsellEnabled: boolean;
  crossSellEnabled: boolean;
  tenantId: string;
  createdAt: string;
  updatedAt: string;
}

export type SalesProfileUpdate = Partial<
  Omit<SalesProfile, 'id' | 'tenantId' | 'createdAt' | 'updatedAt'>
>;

export type SalesExampleCategory = 'OBJECTION' | 'GREETING' | 'CLOSING' | 'PRICING' | 'GENERAL';

export interface SalesExample {
  id: string;
  category: SalesExampleCategory;
  question: string;
  answer: string;
  context: string | null;
  tenantId: string;
  createdById: string;
  createdBy: {
    firstName: string;
    lastName: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateExampleData {
  category: SalesExampleCategory;
  question: string;
  answer: string;
  context?: string | null;
}

export type UpdateExampleData = Partial<CreateExampleData>;

export const CATEGORY_LABELS: Record<SalesExampleCategory, string> = {
  OBJECTION: 'Objeciones',
  GREETING: 'Saludos',
  CLOSING: 'Cierres',
  PRICING: 'Pricing',
  GENERAL: 'General',
};

export const TONE_OPTIONS = [
  { value: 'profesional', label: 'Profesional' },
  { value: 'directo', label: 'Directo' },
  { value: 'amigable', label: 'Amigable' },
  { value: 'consultivo', label: 'Consultivo' },
] as const;

export const CLOSING_STYLE_OPTIONS = [
  { value: 'consultivo', label: 'Consultivo' },
  { value: 'directo', label: 'Directo' },
  { value: 'suave', label: 'Suave' },
  { value: 'urgente', label: 'Urgente' },
] as const;
